"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GeometryType;
(function (GeometryType) {
    GeometryType["Unknown"] = "Unknown";
    GeometryType["Point"] = "Point";
    GeometryType["LineString"] = "LineString";
    GeometryType["Polygon"] = "Polygon";
    GeometryType["MultiPoint"] = "MultiPoint";
    GeometryType["MultiLineString"] = "MultiLineString";
    GeometryType["MultiPolygon"] = "MultiPolygon";
    GeometryType["GeometryCollection"] = "GeometryCollection";
})(GeometryType = exports.GeometryType || (exports.GeometryType = {}));
